<template>
  <div>
  <div class="uploadgrid uploadsetion" :class="{'disableUpload':disableUpload, 'uploadsmall': smallIcons, 'p-0': isColReverse, 'pl-0': invoiceAttach}">
    <Upload
      action=""
      list-type="picture-card"
      :file-list="getAttachments"
      :limit="noLimit ? null : maxAllowed"
      :multiple="multiple"
      :auto-upload="false"
      :on-exceed="handleExceed"
      :on-change="addAttachments"
      :disabled="disableUpload"
      :accept="allowedFormats"
      class="default-upload flex-reverse z-index"
      :class="{'is-disabled':(disableBox || disableUpload), 'col-reverse': isColReverse}">
      <i class="el-icon-plus plus-icon"></i>
      <div class="el-upload-list__item-slot" slot="file" slot-scope="{file}">
        <img class="el-upload-list__item-thumbnail" :src="setIcon(file)" alt="" />
        <span class="el-upload-list__item-actions">
          <span class="el-upload-list__item-preview" v-if="showPreview"
            @click="handlePictureCardPreview(file)">
            <i class="el-icon-zoom-in"></i>
          </span>
          <span v-if="showDeleteBtn" class="el-upload-list__item-delete"
            @click="removeAttachment(file)">
            <i class="el-icon-delete"></i>
          </span>
        </span>
        <div v-if="file.name" class="filenametag">{{ file.name }}</div>
      </div>
    </Upload>
    <a class="download-file" />
    <Dialog :visible.sync="dialogVisible"
      width="80%"
      :append-to-body="true"
      :fullscreen="true"
      custom-class="preview-popup">
    <div class="preview-header text-right" style="margin-right: 20px;">
      <span class="actions">
          <svgicon
          name="rotate-left"
          class="pointer"
          width="20"
          height="20" 
          @click="rotateLeft" />
           <svgicon
          name="rotate-right"
          class="pointer ml-20"
          width="20"
          height="20"
          @click="rotateRight" />
          <svgicon
            name="cancelnocolor"
            class="pointer ml-20"
            width="20"
            height="20"
            @click="dialogVisible = false" />
          </span>
    </div>
    <div class="preview-body">
      <Dialog :visible.sync="dialogVisible" 
      :style="`transform: rotate(${rotation}deg); transition: transform 0.5s ease-in-out`">
      <img width="100%" :src="dialogImageUrl" alt="" />
      </Dialog>
    </div>
    </Dialog>
  </div>
  <div class="text-grey-medium1" v-if="allowedFileFormats.length">
    Supported formats: {{ allowedFileFormats.join(', ').toUpperCase() }}
  </div>
  </div>
</template>

<script type="text/javascript">
import AttachmentConstants from "@common/constants/AttachmentConstants";
import UploadMixin from "../../common-v2/mixins/UploadMixin.vue";
export default {
  props: {
    index: {
      type: Number,
      default: null,
    },
    allowedFileFormats: {
      type: Array,
      default: () => [],
    },
    attachments: {
      type: Array,
      default: () => [],
    },
    showPreview: {
      type: Boolean,
      default: false,
    },
    disableUpload: {
      type: Boolean,
      default: false,
    },
    shipperAttach: {
      type: Boolean,
      default: false,
    },
    disableDelete: {
      type: Boolean,
      default: false,
    },
    smallIcons: {
      type: Boolean,
      default: false,
    },
    noLimit: {
      type: Boolean,
      default: false,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    maxAllowed: {
      type: Number,
      default: 5,
    },
    invoiceAttach: {
      type: Boolean,
      default: false,
    },
    // FOR HACH
    disableBoxOption:{
      type: Boolean,
      default: false,
    },
    disableUploadBox:{
      type: Boolean,
      default: false,
    },
    isEditState:{
      type: Boolean,
      default: false,
    },
    isColReverse: {
      type: Boolean,
      default: false,
    },
    allowDelete: {
      type: Boolean,
      default: false,
    },
    showPreviewInParentComponent: {
      type: Boolean,
      default: false,
    }
  },
  mixins: [UploadMixin],
  computed: {
    getAttachments() {
      return this.attachments;
    },
    disableBox(){
      if(this.disableBoxOption){
        return this.disableUploadBox || !this.isEditState;
      }
      return false;
    },
    enableDelete(){
      if(this.disableBoxOption){
        return this.isEditState && this.disableUploadBox;
      }
      return false;
    },
    allowedFormats(){
      let allowedFileTypes = null;
      if(this.allowedFileFormats.length){
        allowedFileTypes = '.' + this.allowedFileFormats.join(',.');
      }
      return allowedFileTypes;
    },
    showDeleteBtn() {
      return !this.shipperAttach &&
        ((!this.disableUpload && !this.disableDelete && !this.disableBoxOption) ||
         this.enableDelete ||
         this.allowDelete);
    },
  },
  methods: {
    addAttachments(file, fileList) {
      this.addAttachment(file, fileList, this.index, this.allowedFileFormats);
    },
    removeAttachment(file) {
      this.$emit('removeAttachments', file, this.index);
    },
  },
};
</script>
